(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function CreateEvent(evt) {

	if (document.createEvent) {

		var event = document.createEvent('CustomEvent');
		event.initEvent(evt, true, true);
		return event;
	} else {
		return new Event(evt);
	}
}

module.exports = { CreateEvent: CreateEvent };

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    CreateEvent = _require.CreateEvent;

var _require2 = __webpack_require__(2),
    lazyLoadImage = _require2.lazyLoadImage;

var onLoadEventName = 'lazyload';
var onLoad = CreateEvent(onLoadEventName);
var lazySrcDataAttribute = 'data-lazy-src';

/**
 *
 * LazyLoad
 *
 * The base class that provides the functionality to lazy load images, picture elements and CSS background images.
 * LazyLoad doesn't auto trigger any lazy load behaviour internally, it just provides an event driven interface to do so.
 *
 */

var LazyLoad = function () {
  function LazyLoad(selector) {
    _classCallCheck(this, LazyLoad);

    var images = Array.from(document.querySelectorAll(selector));

    if (!images.length) {
      console.warn('No elements matching the selector ' + selector + ' were found, LazyLoad could not initialise');
      return;
    }

    // store lazy load data for each element
    this.images = images.map(function (image) {
      return {
        image: image,
        resolved: false,
        src: getLazySrc(image)
      };
    });

    // listen for the lazyload event on each element
    this.images.forEach(function (lazyImage) {
      lazyImage.image.addEventListener(onLoadEventName, lazyLoadImage.bind(lazyImage));
    });
  }

  // fire lazyload event on element to begin attempting to load


  LazyLoad.prototype.fireLazyLoadEvent = function fireLazyLoadEvent(image) {
    image.dispatchEvent(onLoad);
  };

  return LazyLoad;
}();

// get the filepath to load for each element within an instance


function getLazySrc(image) {

  // if the element is not a picture element return its `data-lazy-src` attribute
  var src = image.getAttribute(lazySrcDataAttribute);

  if (src) {
    return src;
  }

  // if the element is a picture element return an array of srcs from its children (source and img elements)
  var srcs = Array.from(image.children).map(function (child) {

    /**
     *
     * The picturefill polyfill wraps a video element around source elements in IE9.
     * If this is the case the `data-lazy-src` attributes need to be retrieved from within the video element.
     * The srcs will be returned as an array if this is the case so will need flattening.
     *
     */

    if (child.constructor === HTMLVideoElement) {
      return Array.from(child.children).map(function (videoChild) {
        return videoChild.getAttribute(lazySrcDataAttribute);
      });
    } else {
      return child.getAttribute(lazySrcDataAttribute);
    }
  });

  // flatten the array if necessary
  return [].concat.apply([], srcs);
}

module.exports = { LazyLoad: LazyLoad };

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    CreateEvent = _require.CreateEvent;

var onCompleteEventName = 'lazyloadcomplete';
var onErrorEventName = 'lazyloaderror';
var onComplete = CreateEvent(onCompleteEventName);
var onError = CreateEvent(onErrorEventName);

/**
 *
 * loadImage
 *
 * @param { String or Array } src
 * @param { HTMLImageObject } image
 *
 * @return { Promise }
 *
 * Sets the `src` on an image element or `srcset` of source and image elements within a picture element.
 * Responds to its load / error events.
 *
 */

function loadImage(src, image) {

  return new Promise(function (resolve, reject) {

    function onLoad() {
      removeListeners();
      resolve(true);
    }

    function onError() {
      removeListeners();
      reject(false);
    }

    function removeListeners() {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);

    /**
     *
     * If the image is within a picture element, set srcset on each child.
     * Browsers that don't support HTMLPictureElement will report it as an instance of a HTMLUnknownElement.
     *
     */

    if (image.parentNode && image.parentNode.constructor === window.HTMLPictureElement || image.parentNode && typeof window.HTMLPictureElement === 'undefined' && image.parentNode.constructor === window.HTMLUnknownElement || image.parentNode && typeof window.HTMLPictureElement === 'undefined' && image.parentNode.constructor === window.HTMLElement) {

      Array.from(image.parentNode.children).forEach(function (child, i) {

        // IE9 polyfill approach is to use a video element around the source elements
        if (child.constructor !== HTMLVideoElement) {
          child.setAttribute('srcset', src[i]);
        } else {

          // the source elements will be children of the video element in ie9
          Array.from(child.children).forEach(function (videoChild, j) {
            videoChild.setAttribute('srcset', src[i + j]);
          });
        }
      });
    } else {
      image.setAttribute('src', src);
    }
  });
}

// fired upon receipt of the `lazyload` event for each element stored in a LazyLoad instance
function lazyLoadImage() {
  var image = this.image,
      src = this.src;

  // create a dummy image to capture load / error events

  var lazyImage = new Image();

  // if it's a picture element, re-assign the dummy image to the img element within the picture element
  if (image.constructor === window.HTMLPictureElement || typeof window.HTMLPictureElement === 'undefined' && image.constructor === window.HTMLUnknownElement || typeof window.HTMLPictureElement === 'undefined' && image.constructor === window.HTMLElement) {
    lazyImage = image.querySelector('img');
  }

  // get the appropriate callback to fire once an image has loaded
  var onImageLoad = getOnLoadCallback(image);

  loadImage(src, lazyImage).then(function () {
    onImageLoad(image, src);
    image.dispatchEvent(onComplete);
  }).catch(function () {
    image.dispatchEvent(onError);
  });
}

function getOnLoadCallback(image) {
  switch (true) {
    case image.constructor === HTMLImageElement:
      return onShowImage;
    // empty function callback for picture element
    case image.constructor === window.HTMLPictureElement || typeof window.HTMLPictureElement === 'undefined' && image.constructor === window.HTMLUnknownElement || typeof window.HTMLPictureElement === 'undefined' && image.constructor === window.HTMLElement:
      return function () {};
    default:
      return onShowBackgroundImage;
  }
}

function onShowImage(image, src) {
  image.setAttribute('src', src);
}

function onShowBackgroundImage(div, src) {
  div.style.backgroundImage = 'url(' + src + ')';
}

module.exports = {
  lazyLoadImage: lazyLoadImage,
  loadImage: loadImage,
  getOnLoadCallback: getOnLoadCallback,
  onShowImage: onShowImage,
  onShowBackgroundImage: onShowBackgroundImage
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// taken from http://underscorejs.org/#debounce
function debounce(callback, wait, immediate) {

  var timeout = void 0;

  return function bounce() {

    var context = this;
    var args = arguments;

    function later() {
      timeout = null;
      if (!immediate) {
        callback.apply(context, args);
      }
    }

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      callback.apply(context, args);
    }
  };
}

module.exports = { debounce: debounce };

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var _require = __webpack_require__(1),
    LazyLoad = _require.LazyLoad;

var _require2 = __webpack_require__(3),
    debounce = _require2.debounce;

var onFindImagesToLoad = void 0,
    onResize = void 0;

/**
 *
 * LazyScroll
 *
 * Triggers the lazy loading of elements based on their scroll position relative to the viewport.
 * Stores each element's positional data to test after a scroll or resize event.
 *
 */

var LazyScroll = function (_LazyLoad) {
	_inherits(LazyScroll, _LazyLoad);

	function LazyScroll(selector) {
		_classCallCheck(this, LazyScroll);

		var _this = _possibleConstructorReturn(this, _LazyLoad.call(this, selector));

		if (!_this.images) {
			console.warn('No elements matching the selector ' + selector + ' were found, LazyScroll could not initialise');
			return _possibleConstructorReturn(_this);
		}

		// add the positional info of elements to the data stored on the instance
		setLazyImagePositions.call(_this);

		// debounce the scroll and resize event handlers used to test if elements are in the viewport
		onFindImagesToLoad = debounce(findImagesToLoad.bind(_this), 100);
		onResize = debounce(setLazyImagePositions.bind(_this), 100);
		addEventListeners();

		return _this;
	}

	LazyScroll.prototype.rescanViewport = function rescanViewport() {
		findImagesToLoad.call(this);
	};

	return LazyScroll;
}(LazyLoad);

function setLazyImagePositions() {
	this.images = getLazyImagePositions(this.images);
}

// adds positional data to each lazy load element stored on the instance
function getLazyImagePositions(images) {
	return images.map(function (lazyImage) {
		return _extends({}, lazyImage, {
			imagePosition: getImagePosition(lazyImage.image)
		});
	});
}

// find images to load from ones yet to be resolved
function findImagesToLoad() {
	setLazyImagePositions.call(this);
	var imagesToLoad = getImagesInView(this.images);
	loadImages.call(this, imagesToLoad);
}

// attempt to load an element found within the viewport
function loadImages(imagesToLoad) {
	var _this2 = this;

	imagesToLoad.forEach(function (lazyImage) {
		_this2.fireLazyLoadEvent(lazyImage.image);
		lazyImage.resolved = true;
	});
}

function addEventListeners() {
	window.addEventListener('scroll', onFindImagesToLoad);
	window.addEventListener('DOMContentLoaded', onFindImagesToLoad);
	window.addEventListener('resize', onResize);
}

function removeEventListeners() {
	window.removeEventListener('scroll', onFindImagesToLoad);
	window.removeEventListener('DOMContentLoaded', onFindImagesToLoad);
	window.removeEventListener('resize', onResize);
}

// get top and left co-ordinates of an element relative to the document
function getImagePosition(image) {
	var _image$getBoundingCli = image.getBoundingClientRect(),
	    top = _image$getBoundingCli.top,
	    left = _image$getBoundingCli.left,
	    bottom = _image$getBoundingCli.bottom,
	    right = _image$getBoundingCli.right;

	var _window = window,
	    pageXOffset = _window.pageXOffset,
	    pageYOffset = _window.pageYOffset;

	return {
		top: top + pageYOffset,
		left: left + pageXOffset,
		bottom: bottom + pageYOffset,
		right: right + pageXOffset
	};
}

function getWindowScrollPosition() {
	var _window2 = window,
	    pageXOffset = _window2.pageXOffset,
	    pageYOffset = _window2.pageYOffset;

	return { pageXOffset: pageXOffset, pageYOffset: pageYOffset };
}

function getWindowSize() {
	var width = window.innerWidth;
	var height = window.innerHeight;
	return { width: width, height: height };
}

// get the boundaries of the viewport to see if an element is within them
function getWindowBoundaries() {
	var _getWindowScrollPosit = getWindowScrollPosition(),
	    pageXOffset = _getWindowScrollPosit.pageXOffset,
	    pageYOffset = _getWindowScrollPosit.pageYOffset;

	var _getWindowSize = getWindowSize(),
	    width = _getWindowSize.width,
	    height = _getWindowSize.height;

	var xMin = pageXOffset;
	var xMax = pageXOffset + width;
	var yMin = pageYOffset;
	var yMax = pageYOffset + height;
	return { xMin: xMin, xMax: xMax, yMin: yMin, yMax: yMax };
}

function getUnloadedImages(images) {
	return images.filter(function (lazyImage) {
		return !lazyImage.resolved;
	});
}

// test if a yet to be resolved element is horizontally and vertically within the viewport
function getImagesInView(images) {
	var _getWindowBoundaries = getWindowBoundaries(),
	    xMin = _getWindowBoundaries.xMin,
	    xMax = _getWindowBoundaries.xMax,
	    yMin = _getWindowBoundaries.yMin,
	    yMax = _getWindowBoundaries.yMax;

	var unloadedImages = getUnloadedImages(images);

	if (unloadedImages.length === 0) {
		removeEventListeners();
		return [];
	}

	return unloadedImages.filter(function (lazyImage) {
		var _lazyImage$imagePosit = lazyImage.imagePosition,
		    top = _lazyImage$imagePosit.top,
		    left = _lazyImage$imagePosit.left,
		    bottom = _lazyImage$imagePosit.bottom,
		    right = _lazyImage$imagePosit.right;

		return isInViewVertically(top, yMin, bottom, yMax) && isInViewHorizontally(left, xMin, right, xMax);
	});
}

function isInViewVertically(imageTop, windowTop, imageBottom, windowBottom) {
	return imageTop <= windowBottom && imageBottom >= windowTop;
}

function isInViewHorizontally(imageLeft, windowLeft, imageRight, windowRight) {
	return imageLeft <= windowRight && imageRight >= windowLeft;
}

module.exports = {
	LazyScroll: LazyScroll,
	isInViewVertically: isInViewVertically,
	isInViewHorizontally: isInViewHorizontally,
	getWindowScrollPosition: getWindowScrollPosition
};

/***/ })
/******/ ]);
});